










import { Component, Vue } from "vue-property-decorator";
import iconLaba from "@/assets/img/laba.svg";
import { isShowEasyMailRemind } from "@/utils/experiment";
import { inAuthority } from "@/utils/authority";

const EASY_MAIL_NEED_NOTICE = "easy-mail-needNotice";

@Component
export default class EasyMailRemind extends Vue {
  show = false;
  iconLaba = iconLaba;

  created() {
    this.syncShow();
  }
  
  syncShow() {
    const easyMailNeedNotice = localStorage.getItem(EASY_MAIL_NEED_NOTICE);
    if (
      isShowEasyMailRemind() &&
      inAuthority('mailTemplate/list', 'view')
    ) {
      document.documentElement.style.setProperty('--easy-mail-remind-height', '64px');
      this.show = true;
      localStorage.setItem(EASY_MAIL_NEED_NOTICE, "true");
    } else {
      document.documentElement.style.setProperty('--easy-mail-remind-height', '0px');
      this.show = false;
    }
  }

  close() {
    this.show = false;
    document.documentElement.style.setProperty('--easy-mail-remind-height', '0px');
    localStorage.setItem(EASY_MAIL_NEED_NOTICE, "false");
    this.$router.go(0);
  }
}
